export const PROGRAM_TYPES = ["Program", "Support", "Department"];
